import { type AppBusinessModel } from '@bbk/editor-contracts/business';

export {
  AppBusinessModel,
  AppBusinessVertical,
  BUSINESS_MODEL_OPTS,
  BUSINESS_VERTICAL_OPTS,
} from '@bbk/editor-contracts/business';
/**
 * Benchmark types and enums.
 * This file exists to break circular dependencies between benchmark.selectors.ts and app-persist.slice.ts
 */

export type BenchmarkMetricsReport = {
  metrics: {
    business_model: AppBusinessModel;

    min_deflect_rate: number;
    avg_deflect_rate: number;
    max_deflect_rate: number;

    min_save_rate: number;
    avg_save_rate: number;
    max_save_rate: number;

    min_active_deflect_rate: number;
    avg_active_deflect_rate: number;
    max_active_deflect_rate: number;

    min_passive_deflect_rate: number;
    avg_passive_deflect_rate: number;
    max_passive_deflect_rate: number;
  }[];
};

export enum DataLineType {
  deflect_rate = 'deflect_rate',
  save_rate = 'save_rate',
  active_deflect_rate = 'active_deflect_rate',
  passive_deflect_rate = 'passive_deflect_rate',
}

export type BenchmarkMetricLine = {
  type: DataLineType;
  min: number;
  max: number;
  avg: number;
};
